import styles from "../../styles/common/BlockToken.module.scss"

import clsx from "clsx";
import {NumericFormat, NumericFormatProps} from "react-number-format"

import {switchToken} from "../../functions/SwitchToken";

type CurrencyContext = 'balance' | 'transaction' | 'fee' | 'small' | 'technical';

interface BlockTokenProps extends NumericFormatProps {
  extraClassName?: string;
  token?: string;
  hasName?: boolean;
  hasNumberValue?: boolean;
  currencyContext?: CurrencyContext;
  align?: 'left' | 'right' | 'center';
  useMonospace?: boolean;
}

// Get decimal places based on context and amount
const getDecimalPrecision = (context: CurrencyContext = 'balance', amount?: number): number => {
  if (amount !== undefined && Math.abs(amount) < 0.01) {
    return 6; // Very small amounts
  }
  
  switch (context) {
    case 'balance':
      return 2; // Portfolio balances, general amounts
    case 'transaction':
      return 2; // Transaction amounts
    case 'fee':
      return 4; // Fees and interest calculations
    case 'small':
      return 6; // Very small amounts
    case 'technical':
      return 8; // Technical/API views
    default:
      return 2;
  }
};

function BlockToken(
  {
    extraClassName,
    token,
    hasName,
    hasNumberValue,
    currencyContext = 'balance',
    align = 'left',
    useMonospace = false,
    ...rest
  }:BlockTokenProps) {
  // Calculate appropriate decimal scale
  const amount = typeof rest.value === 'number' ? rest.value : parseFloat(rest.value as string || '0');
  const decimalScale = rest.decimalScale ?? getDecimalPrecision(currencyContext, amount);
  
  const containerClasses = clsx(
    styles.cBlockToken, 
    "c-block-token", 
    extraClassName,
    {
      [styles.alignRight]: align === 'right',
      [styles.alignCenter]: align === 'center',
      [styles.monospace]: useMonospace
    }
  );

  return (
    <div className={containerClasses} data-align={align}>
      <i>
        {switchToken(token, "image")}
      </i>

      {hasName && (
        <em className="c-block-token-name">
          {switchToken(token, "name")}
        </em>
      )}

      {hasNumberValue && (
        <NumericFormat
          className="c-block-token-value"
          displayType="text"
          thousandSeparator=","
          decimalSeparator="."
          fixedDecimalScale
          decimalScale={decimalScale}
          {...rest}
        />
      )}

    </div>
  );
}

export default BlockToken;